"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GradeBadge = exports.validGradeSizes = exports.validGradeLetters = exports.gradeColors = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
exports.gradeColors = {
    A: 'green50',
    B: 'green30',
    C: 'yellow50',
    D: 'orange50',
    F: 'red50',
    UNKNOWN: 'neutral40',
};
exports.validGradeLetters = Object.keys(exports.gradeColors);
exports.validGradeSizes = ['sm', 'md', 'lg'];
var fonts = Object.keys(design_system_foundations_1.theme.font);
var expandSizeTheme = function (font, size) { return "\n  ".concat((0, design_system_foundations_1.expandFontTheme)(design_system_foundations_1.theme.font[font]), ";\n  width: ").concat(size, "px;\n  height: ").concat(size, "px;\n"); };
var sizeStyles = {
    lg: expandSizeTheme('titleH1', 80),
    md: expandSizeTheme('titleH3', 40),
    sm: expandSizeTheme('labelStrong', 24),
};
var gradeStyles = function (grade, size) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);\n"], ["\n  ", "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);\n"])), sizeStyles[size], design_system_foundations_1.theme.color[exports.gradeColors[grade]], design_system_foundations_1.theme.color.white, design_system_foundations_1.theme.color.transparent); };
exports.GradeBadge = (0, react_1.forwardRef)(function (_a, ref) {
    var grade = _a.grade, _b = _a.size, size = _b === void 0 ? 'sm' : _b, testId = _a.testId, className = _a.className, style = _a.style, rest = __rest(_a, ["grade", "size", "testId", "className", "style"]);
    if (!exports.validGradeLetters.includes(grade)) {
        throw new Error("Invalid grade, valid grades are [".concat(exports.validGradeLetters, "] and you passed in [").concat(grade, "]."));
    }
    if (size && !exports.validGradeSizes.includes(size)) {
        throw new Error("Invalid size, valid sizes are [".concat(exports.validGradeSizes, "] and you passed in [").concat(size, "]."));
    }
    var classes = (0, css_1.cx)(gradeStyles(grade, size), className, 'ds-grade-badge');
    return (react_1.default.createElement("span", __assign({ className: classes, style: style, "data-testid": testId, ref: ref }, rest), grade === 'UNKNOWN' ? '?' : grade));
});
exports.GradeBadge.displayName = 'GradeBadge';
var templateObject_1;
